import axios, { AxiosResponse } from "axios";
import qs from "qs";
import { BaseURL } from "../constant";
import { Toast } from "antd-mobile";

const instance = axios.create({
  transformRequest: [
    function (data) {
      data = qs.stringify(data);
      return data;
    },
  ],
  // @ts-ignore
  crossDomain: true,
  baseURL: BaseURL,
  withCredentials: true,
});

export function messageResponse(
  response: AxiosResponse,
  onSuccess?: () => void
) {
  if (response.data.Status === "1") {
    Toast.success(response.data.Message);
    onSuccess?.();
  } else {
    Toast.fail(response.data.Message);
  }
}

export default instance;
